module.exports = __webpack_public_path__ + "static/media/fies-e-prouni.0c8a6f9a.jpg";